<template>
    <div class="form-check ms-2" :class="customClass">
        <input :id="uid" :name="name" type="radio" :class="['form-check-input', { 'set-color' : color }]" :style="computedStyle" ref="input" :disabled="disabled" :checked="isChecked" @change="updateModel">
        <label :for="uid" class="form-check-label" :class="{'me-3': 'default' in $slots}">
            <slot name="default"></slot>
        </label>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Emit, Prop, Ref, Watch } from '@/helpers/Decorators';

@Options({
    name: 'ideo-form-radio'
})
export default class IdeoFormRadio extends Vue
{
    public currentValue: any = null;

    @Ref()
    public input: () => HTMLInputElement;

    @Prop()
    public name: string;

    @Prop()
    public checked: any;

    @Prop()
    public modelValue: any;

    @Prop({ required: true })
    public value: any;

    @Prop({ default: false })
    public disabled: boolean;

    @Prop({ default: false })
    public inline: boolean;
    
    @Prop({ default: '' })
    public color: string;

    public get uid(): string
    {
        return `__IDEO__${this.$.uid}__`;
    }

    public get isChecked(): boolean
    {
        return this.currentValue === this.value;
    }

    public get customClass(): Record<string, boolean>
    {
        return {
            'form-check-inline': this.inline === true
        };
    }

    @Emit('change', { noEmitUndefined: true })
    @Emit('update:modelValue', { noEmitUndefined: true })
    public updateModel(e: Event): any
    {
        const target = e.target as HTMLInputElement;

        if (this.name && target.checked == true)
        {
            document.getElementsByName(this.name).forEach(el =>
            {
                const element = el as HTMLInputElement;

                if (element !== target)
                {
                    element.checked = false;
                    element.dispatchEvent(new Event('change'));
                }
            });
        }

        if (target.checked)
            return this.value;
        else if (this.value === true || this.value === false)
            return !this.value;
        else
            return undefined;
    }

    @Watch('checked', { immediate: true })
    public onCheckedChanged(value: any[] | any): void
    {
        if (value !== undefined)
        {
            this.currentValue = value;
        }
    }

    @Watch('modelValue', { immediate: true })
    public onModelChanged(value: any[] | any): void
    {
        if (value !== undefined)
        {
            this.currentValue = value;
        }
    }

    public get computedStyle()
    {
        return {'--color-radio': this.color };
    }
}
</script>
<style scoped>
.form-check-input.set-color:checked {
    background-color: var(--color-radio);
    border-color: var(--color-radio);
}
</style>
